export default {
  清空条件: 'Clear Conditions',
  任务中心: 'Task Center',
  请选择状态: 'Please select a status',
  请选择类型: 'Please select a type',
  下载异常详情: 'Download exception details',
  下载校准详情: 'Download calibration details',
  重试: 'Retry',
  耗时: 'Cost',
  年: 'Years',
  月: 'Months',
  日: 'Days',
  时: 'Hours',
  分: 'Minutes',
  秒: 'Seconds'
};
